module.exports = __webpack_public_path__ + "img/metro_L1.4c71a65e.svg";